import { render, staticRenderFns } from "./uploadBox.vue?vue&type=template&id=13030686"
import script from "./uploadBox.vue?vue&type=script&lang=js"
export * from "./uploadBox.vue?vue&type=script&lang=js"
import style0 from "./uploadBox.vue?vue&type=style&index=0&id=13030686&prod&lang=scss"
import style1 from "./uploadBox.vue?vue&type=style&index=1&id=13030686&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports